
// import { useEffect, useState } from "react";
// import axios from "axios";

// function AdminPanel() {
//   const [currentStatus, setCurrentStatus] = useState(null);
//   const [inputValue, setInputValue] = useState("");

//   const API_URL = "http://localhost:3002/004phonetracker";

//   // 🔹 Page load par GET API
//   const fetchStatus = async () => {
//     try {
//       const res = await axios.get(API_URL);
//       setCurrentStatus(res.data.isAdOnOff);
//     } catch (err) {
//       console.error("GET error:", err);
//     }
//   };

//   useEffect(() => {
//     fetchStatus();
//   }, []);

//   // 🔹 Button click par POST API
//   const updateStatus = async () => {
//     if (inputValue !== "true" && inputValue !== "false") {
//       alert("Please enter only true or false");
//       return;
//     }

//     try {
//       await axios.post(API_URL, {
//         status: inputValue === "true"
//       });

//       // Pachhi updated value GET karo
//       fetchStatus();
//       setInputValue("");
//     } catch (err) {
//       console.error("POST error:", err);
//     }
//   };

//   return (
//     <div style={{ padding: 20 }}>
//       <h2>Ad Control Panel</h2>

//       <p>
//         Current Ad Status :
//         <b style={{ marginLeft: 5, color: currentStatus ? "green" : "red" }}>
//           {currentStatus === null ? "Loading..." : currentStatus ? " true" : " false"}
//         </b>
//       </p>

//       <input
//         type="text"
//         placeholder="true or false"
//         value={inputValue}
//         onChange={(e) => setInputValue(e.target.value)}
//       />

//       <br /><br />

//       <button onClick={updateStatus}>
//         Update Status
//       </button>
//     </div>
//   );
// }

// export default AdminPanel;


import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./component/Login";
import ProtectedRoute from "./component/ProtectedRoute";
import Vpn002 from "./component/Vpn002";
import Phonetraker from "./component/Phonetraker";
import Gpscamera003 from './component/Gpscamera003';

function App() {
 

  return (
   <>
   {/* <Homepage/> */}
   <BrowserRouter>
   
    <Routes>
      <Route path="/" element={<Login/>}/>
       <Route
          path="/phonetracker"
          element={
            <ProtectedRoute>
              <Phonetraker />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vpn002"
          element={
            <ProtectedRoute>
              <Vpn002 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gpscamera003"
          element={
            <ProtectedRoute>
              <Gpscamera003 />
            </ProtectedRoute>
          }
        />

      </Routes>
   </BrowserRouter>
   </>
  );
}

export default App;
